import { irisTrackerService } from 'packages/common/services';
import { isUserAccountant } from 'packages/common/services/user';

const origin = 'PERSONNEL_DEPARTMENT';
const catalogName = 'personnelDepartment';

export const clickSaveWorkerTracker = () => {
  const catalog = irisTrackerService.getCatalog(catalogName);
  return irisTrackerService.buildTracker({
    catalog,
    view: catalog.views.workerWizard,
    origin,
  }).setAction(catalog.actions.clickSaveWorker)
    .send();
};

export const clickNewWorker = () => {
  const catalog = irisTrackerService.getCatalog(catalogName);
  return irisTrackerService.buildTracker({
    catalog,
    view: catalog.views.workerWizard,
    origin,
  }).setAction(catalog.actions.clickNewWorker)
    .send();
};
export const clickToGoWorkerJobInfoFormPage = () => {
  const catalog = irisTrackerService.getCatalog(catalogName);
  return irisTrackerService.buildTracker({
    catalog,
    view: catalog.views.workerWizard,
    origin,
  }).setAction(catalog.actions.clickToGoWorkerJobInfoFormPage)
    .send();
};
export const clickToGoWorkerContractInfoFormPage = () => {
  const catalog = irisTrackerService.getCatalog(catalogName);
  return irisTrackerService.buildTracker({
    catalog,
    view: catalog.views.workerWizard,
    origin,
  }).setAction(catalog.actions.clickToGoWorkerContractInfoFormPage)
    .send();
};

export const clickToGoWorkerShiftInfoPage = () => {
  const catalog = irisTrackerService.getCatalog(catalogName);
  return irisTrackerService.buildTracker({
    catalog,
    view: catalog.views.workerWizard,
    origin,
  }).setAction(catalog.actions.clickToGoWorkerShiftInfoPage)
    .send();
};

export const clickToGoWorkerConcludeWizardStep = () => {
  const catalog = irisTrackerService.getCatalog(catalogName);
  return irisTrackerService.buildTracker({
    catalog,
    view: catalog.views.workerWizard,
    origin,
  }).setAction(catalog.actions.clickToGoWorkerConcludeWizardStep)
    .send();
};

export const clickSubmitNewWorkerFeedback = properties => {
  const catalog = irisTrackerService.getCatalog(catalogName);

  return irisTrackerService.buildTracker({
    catalog,
    view: catalog.views.workerWizard,
    origin,
  }).setAction(catalog.actions.clickSubmitNewWorkerFeedback)
    .setAdditionalInfo({
      ...properties,
      isAccountant: isUserAccountant(),
    })
    .send();
};
